import axiosPost from "./axiosPost";

export const RNHNivelDel = async (credentials, data) => {
    const body = {
        service: "RNHNivelDel",
        params: {
            rnhNivelId: data?.id || null,
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
